import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { SupportService } from 'src/app/shared/services/support.service';

export interface ISupportEmailDraft {
  to: string;
  subject: string;
  body: string;
  siteName: string;
}

@Injectable({
  providedIn: 'root',
})
export class EmailSupportService {
  constructor(
    private stateManagementService: StateManagementService,
    private supportService: SupportService,
    private translate: TranslateService
  ) {}

  isEmailSupportAvailable(): boolean {
    return !this.supportService.isWeiserBrand();
  }

  buildDraft(): ISupportEmailDraft {
    const sharedData = this.stateManagementService.getSharedData();
    const siteName = (sharedData?.selectedSite?.siteName as string) || '';

    const subject = this.translate.instant('EMAIL_SUPPORT_SUBJECT', {
      siteName,
    });

    const greeting = this.translate.instant('EMAIL_SUPPORT_BODY_GREETING');
    const intro = this.translate.instant('EMAIL_SUPPORT_BODY_INTRO');
    const issueLabel = this.translate.instant(
      'EMAIL_SUPPORT_LABEL_ISSUE_DESCRIPTION'
    );
    const issuePlaceholder = this.translate.instant(
      'EMAIL_SUPPORT_ISSUE_PLACEHOLDER'
    );

    const body = [
      greeting,
      '',
      intro,
      '',
      `${issueLabel}:`,
      issuePlaceholder,
    ].join('\n');

    return {
      to: CONSTANTS.SUPPORT_EMAIL_KWIKSET,
      subject,
      body,
      siteName,
    };
  }

  openInMailClient(to: string, subject: string, body: string): void {
    const mailto = `mailto:${to}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
  }
}
